import { render, staticRenderFns } from "./ExchangeCenter.vue?vue&type=template&id=4fdaa176&scoped=true&"
import script from "./ExchangeCenter.vue?vue&type=script&lang=js&"
export * from "./ExchangeCenter.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeCenter.vue?vue&type=style&index=0&id=4fdaa176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdaa176",
  null
  
)

export default component.exports